module.exports = __webpack_public_path__ + "static/287894455.3922b87a.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/components/c-footer/img/287894455.png
// module id = 741
// module chunks = 2